<style lang="scss" scoped>
  ::v-deep .el-dialog {
    position: absolute;
    top: 60px;
    left: 50px;
    right: 50px;
    margin-top: 6vh !important;
    width: 600px;
    height: auto;
    bottom: auto;
    display: grid;
    grid-template-rows: 54px 1fr 12px;

    .el-dialog__footer {
      text-align: center;
      padding: 20px 0 0;
    }

    .el-dialog__header {
      background-color: rgba(38, 79, 120, 1);
      padding: 20px 20px 10px;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 18px;
      color: #eae0e5;
    }

    .el-dialog__body {
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0;

      embed {
        width: 100%;
        height: 100%;
      }
    }
  }

  .pdfWrapper {
    > span {
      display: block !important;
    }
  }

</style>
<template>
  <el-dialog
    title="温馨推荐"
    v-if="advert != null && advert.status != 0"
    :visible="dialogVisible"
    @update:visible="handleUpdateVisible"
  >
    <div class="pdfWrapper" style="padding-top: 24px;">
      <a :href="advert.img_url !== '' ? advert.img_url : '#'" target="_blank"
         v-show="img_src != ''">
        <img :src="img_src" style="max-height: 23vw">
      </a>
      <span style="margin: 2vw; line-height: 20px;">
        <a style="text-decoration: none;color: #000000"
           :href="advert.content_url !== '' ? advert.content_url : '#'" target="_blank"
           v-show="img_src != ''">
          {{advert.content}}
        </a>
      </span>
    </div>
  </el-dialog>
</template>
<script>
  import {
    getMyExam,
    showAd,
  } from '@/services/getData';
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        advert: null,
        img_src: '',
      };
    },
    methods: {
      handleUpdateVisible(e) {
        //点击esc和右上角的x会在dialog里emit update:visible事件
        this.$emit('update:dialogVisible', false);
      },
      loadData() {
        const adminTicket = this.authority && this.authority.admissionTicket;
        getMyExam(adminTicket)
          .then((resp) => {
            if (resp.examination_category_id) {
              showAd(resp.examination_category_id)
                .then((result) => {
                  this.advert = result.advert;
                  if (result.advert.img_file != null) {
                    this.img_src = this.advert.img_file.driver_baseurl + this.advert.img_file.filename;
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
    components: {},
    created() {
    },
    mounted() {
      this.loadData();
    },
    props: {
      dialogVisible: {
        type: Boolean,
      },
    },
    computed: {
      ...mapState({
        authority: 'authority',
        examinee: 'examinee',
        currentUser: 'currentUser',
        myExam: 'myExam',
        serverTime: 'serverTime',
      }),
    },
  };
</script>
